module.exports = __webpack_public_path__ + "media/images/countryrect/pg-9b0486c8f3d7abc9d670756542164dcc.svg";